module.exports = __webpack_public_path__ + "static/media/slideshow (6).3a3061c0.png";